import service from "../service";
import { getApiBaseUrl } from "../config";

export default {
    async getProductList() {
        const response = await service.get(`${getApiBaseUrl()}product`);
        return response;
    },

    async getCategoryProductList(category) {
        const response = await service.get(
            `${getApiBaseUrl()}product/category/${category}`
        );
        return response;
    },

    async searchProduct(searchName) {
        const response = await service.get(
            `${getApiBaseUrl()}product/search/${searchName}`
        );
        return response;
    },

    async addProduct(product) {
        const response = await service.post(
            `${getApiBaseUrl()}product`,
            product
        );
        return response;
    },

    async updateProduct(product) {
        const response = await service.patch(
            `${getApiBaseUrl()}product`,
            product
        );
        return response;
    },

    async deleteProduct(product_id) {
        const response = await service.delete(
            `/api/product/remove/${product_id}`
        );
        return response;
    },

    async verifyProduct(args) {
        const response = await service.get(
            `${getApiBaseUrl()}serialnumber/verify`,
            args
        );
        return response;
    },

    async registerProductUser(args) {
        const response = await service.patch(
            `${getApiBaseUrl()}serialnumber/registeruser`, args
        )
        return response
    }
};
